import { render, staticRenderFns } from "./iconError.vue?vue&type=template&id=74751af2&scoped=true"
import script from "./iconError.vue?vue&type=script&lang=js"
export * from "./iconError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74751af2",
  null
  
)

export default component.exports